const tipPaths = {
  TIP: "",
  SEARCH_TIPS: "search",
  TIP_ID: (id) => id,
  SEARCH_TIPS_REPORT: "search/report",
  SEARCH_TIPS_REPORT_EXPORT: "search/report/export",
};

export default tipPaths;
